import JsComponent from '../jsComponent/jsComponent.js';

class SidebarMenu extends JsComponent {
  constructor(mainElement, name = 'sidebar-menu') {
    super(mainElement, name);
  }
}

export default SidebarMenu;
